import script from "./comment_popup.vue?vue&type=script&setup=true&lang=js"
export * from "./comment_popup.vue?vue&type=script&setup=true&lang=js"

import "./comment_popup.vue?vue&type=style&index=0&id=7406af08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7406af08"]])

export default __exports__